export const base_path = "/";
export const image_path = "/";

// Set by public/config.js, loaded via a synchronous <script> tag in index.html before this
// bundle runs — edit that file directly on the deployed server (no rebuild needed) to point
// the app at a different API. Falls back to the build-time default if config.js is missing.
export const api_base_url = window.APP_CONFIG?.BASE_URL || "https://dcm-api.ezyerp.biz";
